import { render } from "./UserChangePassword.vue?vue&type=template&id=664f7890&scoped=true&ts=true"
import script from "./UserChangePassword.vue?vue&type=script&lang=ts"
export * from "./UserChangePassword.vue?vue&type=script&lang=ts"

import "./UserChangePassword.vue?vue&type=style&index=0&id=664f7890&lang=scss&scoped=true"
import "./UserChangePassword.vue?vue&type=style&index=1&id=664f7890&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664f7890"]])

export default __exports__